var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRtf = function SvgRtf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 40,
    viewBox: "0 0 25 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00456F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.933 10.732a.67.67 0 0 0-.16-.436L18.149 2.73l-.005-.004a.67.67 0 0 0-.31-.195q-.02-.005-.037-.012a.7.7 0 0 0-.155-.019H1.363C.621 2.5.016 3.105.016 3.847v31.66c0 .743.605 1.347 1.347 1.347h22.23c.743 0 1.347-.604 1.347-1.347V10.808q-.001-.037-.007-.076M8.317 34.697c-.121-.21-.298-.814-.518-1.727-.198-.925-.516-1.178-1.2-1.188h-.505v2.915H4.432V27.38c.54-.088 1.342-.154 2.234-.154 1.1 0 1.87.165 2.398.583.44.352.683.869.683 1.551 0 .947-.672 1.595-1.31 1.827v.033c.517.209.803.704.99 1.386.231.836.462 1.805.605 2.09zm7.78-6.007h-2.025v6.007H12.39V28.69h-1.992V27.28h5.7zm5.425-.034h-2.85v1.695h2.663v1.364h-2.663v2.982H16.99v-7.416h4.533zM1.363 25.375V3.847H16.97v6.893c0 .372.301.674.673.674h5.95l.001 13.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.853 28.47a4 4 0 0 0-.76.055v2.046h.661c.836 0 1.332-.418 1.332-1.067 0-.683-.463-1.024-1.233-1.035"
  }))));
};
export default SvgRtf;